import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Layout from '../Layout/Layout';

/**
 * Default landing for /content. Sub-navigation lives in the global
 * SectionChipBar (rendered inside Layout); this page is just the "All" tab
 * placeholder — a quick orientation card pointing the user at the three
 * content types they can manage. Shows is now its own top-level sidebar
 * item, so it no longer appears here.
 */
export default function ContentHome() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const tiles = [
    { i18n: 'nav.content_files',     icon: 'pi pi-images', desc: 'content.tiles.files',     to: '/media/gallery' },
    { i18n: 'nav.content_playlists', icon: 'pi pi-list',   desc: 'content.tiles.playlists', to: '/playlist/list' },
    { i18n: 'nav.content_links',     icon: 'pi pi-link',   desc: 'content.tiles.links',     to: '/links' },
  ];

  return (
    <Layout>
      <div className="container-fluid py-3">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h2 className="pp-page-title mb-0">
            <i className="pi pi-folder-open" /> {t('nav.content')}
          </h2>
        </div>
        <p className="text-muted mb-4">{t('content.subtitle')}</p>

        <div className="row g-3">
          {tiles.map((tile) => (
            <div key={tile.i18n} className="col-12 col-md-6 col-xl-4">
              <Link to={tile.to} className="text-decoration-none">
                <div className="pp-card p-4 h-100 d-flex flex-column gap-2 hover-lift">
                  <span className="pp-empty-icon" style={{ width: 48, height: 48, fontSize: '1.3rem' }}>
                    <i className={tile.icon} />
                  </span>
                  <h5 className="mb-0 mt-2" style={{ color: 'var(--pp-text-primary)', fontWeight: 700 }}>
                    {t(tile.i18n)}
                  </h5>
                  <p className="mb-0 small text-muted">{t(tile.desc)}</p>
                  <span className="small fw-semibold mt-auto" style={{ color: 'var(--pp-btn-honey)' }}>
                    {t('common.open')} <i className="pi pi-arrow-right" style={{ fontSize: '0.75rem' }} />
                  </span>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
